import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

export const removeEmptyAttributes = (changeRequest: EventChangeRequest) => ({
    ...changeRequest,
    attributes: changeRequest.attributes.filter(({name, description, fieldType, possibleValues}) =>
        Boolean(name || description || fieldType || possibleValues.length),
    ),
});
